import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class GeoIpApi {
  private getGeoIpInfoApi = 'getUserLocation';

  constructor(private http: HttpClient) {}

  getGeoIpInfo(): Observable<any> {
    return this.http.get(`${environment.prospektrBackendBaseURL}${this.getGeoIpInfoApi}`);
  }
}
